import { render, staticRenderFns } from "./TestCKEditorForm.vue?vue&type=template&id=e8f492ca&scoped=true&"
import script from "./TestCKEditorForm.vue?vue&type=script&lang=js&"
export * from "./TestCKEditorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f492ca",
  null
  
)

export default component.exports